/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 133 20"
    data-name="SvgRectangle05"
    {...props}
  >
    {props.children}
    <path
      fill="#fff"
      d="M.243 1.651A1 1 0 0 1 1.002 0h121.825c5.523 0 10 4.477 10 10s-4.477 10-10 10H1.002a1 1 0 0 1-.76-1.65L7.403 10z"
    />
  </svg>
)
